<template>
  <div id="app">
	  <keep-alive >
		  <router-view v-wechat-title='$route.meta.title' v-if="$route.meta.keepAlive" :key='$route.fullPath'></router-view>   		  
	  </keep-alive>
	  <router-view v-wechat-title='$route.meta.title' v-if="!$route.meta.keepAlive"></router-view>
	 
  </div>
</template>

<script>
window.onload = function() {
  document.addEventListener('touchstart', function(event) {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  })
  document.addEventListener('gesturestart', function(event) {
    event.preventDefault()
  })
}

import {mapState} from "vuex"
export default {
  name: 'app',
  components: {
 
  },
  mounted() {
	         (function() {	  
	             if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
	                 handleFontSize();
	             } else {
	                 if (document.addEventListener) {
	                     document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
	                 } else if (document.attachEvent) {
	                     document.attachEvent("WeixinJSBridgeReady", handleFontSize);
	                     document.attachEvent("onWeixinJSBridgeReady", handleFontSize);  }
	             }
	             function handleFontSize() {
	                 // 设置网页字体为默认大小
	                 WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 });
	                 // 重写设置网页字体大小的事件
	                 WeixinJSBridge.on('menu:setfont', function() {
	                     WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 });
	                 });
	             }
	         })();
  },
  created(){ 
		if(this.$store.state.token){
			this.$store.dispatch('cartGetAsync')
		}
     },

}
</script>

<style>
#app {
  font-family: 'Microsoft Yahei', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; 
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
}

</style>
<style scoped>
	>>> .van-nav-bar .van-icon {
		  color: #444444;
		  font-size: 22px;
		}
	>>>	.van-nav-bar__text{
		color: #444444;
		text-decoration: underline;
		font-size: 18px;
	}
	
</style>
